import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_ROSTER_EMPLOYEES_REQUEST',
  'GET_ROSTER_EMPLOYEES_SUCCESS',
  'GET_ROSTER_EMPLOYEES_ERROR'
);
